import React from 'react';
import { useNavigate } from 'react-router-dom';

import ForbiddenImg from '@/assets/images/forbidden-image.png';
import ButtonCustom from '@/components/common/ui/button';
import PATH from '@/routes/path';

const ForbiddenPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="flex-full-center flex-col h-screen bg-white">
      <div className="w-[461.48px] h-[500px]">
        <img
          className="w-[100%] h-[100%] object-cover"
          src={ForbiddenImg}
        ></img>
      </div>

      <ButtonCustom
        className="mt-[42px] w-[314px] h-[44px]"
        onClick={() => navigate(PATH.login)}
      >
        戻る
      </ButtonCustom>
    </div>
  );
};

export default ForbiddenPage;
